import * as React from "react";

import * as Autosuggest from 'react-autosuggest';

import { Header, Navigation, Footer } from "../../shared";
import { AdministrationMenu } from "../shared/menu/AdministrationMenu";
import { TablePermission } from './TablePermission';
import { TablePermissionDetail } from './detail/TablePermissionDetail';
import "./Permission.scss";

import {
    Button,
    Card,
    CardContent,
    CardActions,
    FormControl,
    FormGroup,
    Grid,
    InputLabel,
    MenuItem,
    Paper,
    Select,
    Snackbar,
    SnackbarContent
} from '@material-ui/core';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

import Rest from "../../../services/Rest";

const QUERY_GET_USERS = ` query { allActiveUsers { id, fullname } } `;

const QUERY_GET_BOOKSTORES = ` query { allActiveBookstores { id, tranding_name } } `;

const QUERY_GET_PUBLISHERS = ` query { allActivePublishers { id, provider } } `;

const QUERY_GET_PROFILES = ` query { allActiveProfiles { id, name } } `;

const QUERY_SAVE_PERMISSION = 
    ` query savePermission($customFilter: PermissionRegisteredFilter) {
        savePermission(permissionRegisteredFilter: $customFilter) {
            profile_id,
            publisher_id,
            store_id,
            user_id 
        } 
    } `;

const styles = {
    textField: {
      marginLeft: 5,
      marginRight: 5,
    },
};

// tslint:disable-next-line:no-empty-interface
export interface IPermissionProps {
}

// tslint:disable-next-line:no-empty-interface
export interface IPermissionState {
    alertMessage: string,
    alertOpened: boolean,
    alertType: string,

    allProfiles: any[],
    allPublishers: any[],
    allStores: any[],
    allUsers: any[],

    dataToDetail: any,

    isDetail: boolean,

    permission: {
        profile_id: number,
        publisher_id: number,
        publisher_name: string,
        store_id: number,
        store_name: string,
        user_id: number,
        user_name: string
    },
    publishers: any[],
    stores: any[],
    users: any[]
}

export class Permission extends React.Component<IPermissionProps, IPermissionState> {

    private tablePermission: React.RefObject<TablePermission>;
    private tablePermissionDetail: React.RefObject<TablePermissionDetail>;
    constructor(props: IPermissionProps) {
        super(props);
        this.tablePermission = React.createRef();
        this.tablePermissionDetail = React.createRef();

        this.state = {
            alertMessage: '',
            alertOpened: false,
            alertType: 'success',

            allProfiles: [],
            allPublishers: [],
            allStores: [],
            allUsers: [],

            dataToDetail: {},

            isDetail: false,

            permission: {
                profile_id: 0,
                publisher_id: 0,
                publisher_name: '',
                store_id: 0,
                store_name: '',
                user_id: 0,
                user_name: ''
            },
            publishers: [],
            stores: [],
            users: []
        }
        this.getUsers = this.getUsers.bind(this);
        this.getBookstores = this.getBookstores.bind(this);
        this.getPublishers = this.getPublishers.bind(this);
        this.getProfiles = this.getProfiles.bind(this);

        this.receivePermissionToDetail = this.receivePermissionToDetail.bind(this);
        this.handleReturnToMacroPermissions = this.handleReturnToMacroPermissions.bind(this);
    }

    public componentWillMount () {
        this.getUsers();
        this.getBookstores();
        this.getPublishers();
        this.getProfiles();
    };
    
    public render() {
        const dataToFilter:any = this.state.permission;

        return (
        <div className="permission-page">
            <Header title={"Cadastro de Permissões"} name={"Administrativo"} link={"/dashboard"} />

            <Navigation name={"Cadastro de Permissões"}
                linkDefault={"/administration/permission"}
                link={"/dashboard"}
                linkTitle={"Produtos"}
                painel={3}
                icon={<ChevronRightIcon />}
            />
        
            <div className="permission-body">
                <AdministrationMenu paramIcon={null} />

                <div className="wrapper">
                    <Grid
                        container={true}
                        className="permission-panel panel-grid"
                        spacing={16}
                    >

                        <Grid item={true} xs={12} >
                            <div>
                                <Paper>
                                    <Grid container={true} direction="column" spacing={16}>
                                        <Grid item={true}>
                                            <Snackbar
                                                anchorOrigin={{
                                                    horizontal: 'center',
                                                    vertical: 'center',
                                                }}
                                                open={this.state.alertOpened}
                                                autoHideDuration={4000}
                                                onClose={this.closeAlert}
                                            >
                                                <SnackbarContent message={this.state.alertMessage} style={this.alertStyle()}/>
                                            </Snackbar>
                                            <Card>
                                                <form>
                                                    <CardContent>
                                                        <FormGroup row={true}>
                                                            <div className="autocomplete-input">
                                                                <Autosuggest
                                                                    getSuggestionValue={this.getSuggestionValueUser}
                                                                    inputProps={
                                                                        {
                                                                            onChange: this.onChangeUser,
                                                                            placeholder: 'Usuário *',
                                                                            value: this.state.permission.user_name
                                                                        }
                                                                    }
                                                                    onSuggestionsClearRequested={this.onSuggestionsClearRequestedUser}
                                                                    onSuggestionSelected={this.onSuggestionSelectedUser}
                                                                    onSuggestionsFetchRequested={this.onSuggestionsFetchRequestedUser}
                                                                    renderSuggestion={this.renderSuggestionUser}
                                                                    suggestions={this.state.users}
                                                                />
                                                            </div>

                                                            <FormControl className="profileSelectInput">
                                                                <InputLabel htmlFor="profile">Perfil</InputLabel>
                                                                <Select
                                                                    value={this.state.permission.profile_id}
                                                                    onChange={this.handleChangeSelect}
                                                                    inputProps={{
                                                                        id: 0,
                                                                        name: 'profile_id',
                                                                    }}
                                                                >
                                                                    <MenuItem value={0}>{''}</MenuItem>
                                                                    {
                                                                        this.state.allProfiles.map((profile:any, key:number) => (
                                                                            <MenuItem value={profile.id}>{profile.name}</MenuItem>
                                                                        ))
                                                                    }
                                                                </Select>
                                                            </FormControl>
                                                        </FormGroup>

                                                        <FormGroup row={true}>
                                                            <div className="autocomplete-input">
                                                                <Autosuggest
                                                                    getSuggestionValue={this.getSuggestionValuePublisher}
                                                                    inputProps={
                                                                        {
                                                                            onChange: this.onChangePublisher,
                                                                            placeholder: 'Editora *',
                                                                            value: this.state.permission.publisher_name
                                                                        }
                                                                    }
                                                                    onSuggestionsClearRequested={this.onSuggestionsClearRequestedPublisher}
                                                                    onSuggestionSelected={this.onSuggestionSelectedPublisher}
                                                                    onSuggestionsFetchRequested={this.onSuggestionsFetchRequestedPublisher}
                                                                    renderSuggestion={this.renderSuggestionPublisher}
                                                                    suggestions={this.state.publishers}
                                                                />
                                                            </div>
                                                        
                                                        
                                                            <div className="autocomplete-input">
                                                                <Autosuggest
                                                                    getSuggestionValue={this.getSuggestionValueStore}
                                                                    inputProps={
                                                                        {
                                                                            onChange: this.onChangeStore,
                                                                            placeholder: 'Livraria *',
                                                                            value: this.state.permission.store_name
                                                                        }
                                                                    }
                                                                    onSuggestionsClearRequested={this.onSuggestionsClearRequestedStore}
                                                                    onSuggestionSelected={this.onSuggestionSelectedStore}
                                                                    onSuggestionsFetchRequested={this.onSuggestionsFetchRequestedStore}
                                                                    renderSuggestion={this.renderSuggestionStore}
                                                                    suggestions={this.state.stores}
                                                                />
                                                            </div>
                                                        </FormGroup>
                                                    </CardContent>
                                                    <CardActions>
                                                        <div>
                                                            {this.state.isDetail && 
                                                                <Button className="filter-dialog-close" color="primary" onClick={this.handleReturnToMacroPermissions}>
                                                                    Voltar
                                                                </Button>
                                                            }
                                                            <Button className="filter-dialog-clear" onClick={this.handleClearAllForm}>
                                                                Limpar
                                                            </Button>
                                                            {!this.state.isDetail && 
                                                                <Button className="filter-dialog-close" color="primary" onClick={this.searchPermission.bind(this,null)}>
                                                                    Pesquisar
                                                                </Button>
                                                            }
                                                        </div>
                                                        <div>
                                                        
                                                            <Button variant="contained" className="filter-dialog-close" color="primary" onClick={this.save}>
                                                                    Salvar
                                                            </Button>
                                                        </div>
                                                    
                                                    </CardActions>
                                                </form>
                                            </Card>
                                            <Card>
                                                <CardContent>
                                                    {!this.state.isDetail ? 
                                                        <TablePermission dataToFilter={...dataToFilter} receivePermissionToDetail={this.receivePermissionToDetail} ref={this.tablePermission} /> :
                                                        <TablePermissionDetail dataToDetail={...this.state.dataToDetail}  ref={this.tablePermissionDetail} />

                                                    }
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </div>
                        </Grid>
                    </Grid>
                </div>
            </div>
            <div className="permission-footer">
                <Footer />
            </div>
        </div>
        );
    }

    /**
     * Métodos recebe permissão para ser editada
     */
    private receivePermissionToDetail (permission:any) {
        this.setState( {isDetail: true, dataToDetail:permission} );
    }

    private handleReturnToMacroPermissions () {
        this.setState( {isDetail: false, dataToDetail:null } );
        this.searchPermission(null);
    }

    /**
     * Métodos manipulação do formulário
     */
    private handleClearAllForm = () => {
        const permission = {
            profile_id: 0,
            publisher_id: 0,
            publisher_name: '',
            store_id: 0,
            store_name: '',
            user_id: 0,
            user_name: ''
        };

        this.searchPermission(permission);

        this.setState({
            permission,
            publishers: [],
            stores: [],
            users: []
        });
    }

    private searchPermission = (previewPermission:any) => {
        if(this!= null && this.tablePermission != null && this.tablePermission.current != null) {

            let dataToSearch = previewPermission;
            if(!dataToSearch) {
                dataToSearch = this.state.permission;
            }

            this.tablePermission.current.changeState(dataToSearch);
        }
    }

    private save = () => {

        if (this.validDataForSave()) {
            const customFilter : any = {
                "customFilter": {
                    "profile_id": this.state.permission.profile_id,
                    "publisher_id": this.state.permission.publisher_id,
                    "store_id": this.state.permission.store_id,
                    "user_id": this.state.permission.user_id
                }
            };

            const body = {
                "operationName":"",
                "query":QUERY_SAVE_PERMISSION,
                "variables": customFilter
            };
        
            Rest.GraphqlPOST(body)
                .then( result  => {
                    if(result.data.errors && !result.data.data.savePermission) {
                        let messageErro = "Falha ao salvar registro.";
                        if(result.data.errors && result.data.errors[0] && result.data.errors[0].message) {
                            messageErro = messageErro+" "+result.data.errors[0].message;
                        }
                        this.errorSaveStore(messageErro);
                    } else {
                        this.storeSuccessSaved();
                        this.preparePermissionFormAfterSave(result.data.data.savePermission.user_id);
                        setTimeout(
                            this.searchPermission(null), 3000
                        );
                        this.forceUpdate();
                    }
                }).catch(err => {
                    let errorMessage = 'Falha ao salvar registro.';
                    if(err != null && err !== undefined && err.message !=null && err.message !== undefined && err.message !== "") {
                        errorMessage = err.message;
                    }
                    this.errorSaveStore(errorMessage);
                });
        }
    }

    private validDataForSave = () => {
        let messageValidation = 'É obrigatório informar: ';

        if(!this.state.permission.profile_id) {
            messageValidation += " Perfil.";
        } else {
            // Caso seja livraria, deve ter livraria associada
            // Caso seja editora, deve ter editora associada
            if(this.state.permission.profile_id===1 && !this.state.permission.store_id) {
                messageValidation += " Livraria.";
            } else if (this.state.permission.profile_id===3 && !this.state.permission.publisher_id) {
                messageValidation += " Editora.";
            }
        }

        if(!this.state.permission.user_id) {
            messageValidation += " Usuário.";
        }

        if(messageValidation !== 'É obrigatório informar: ') {
            this.errorSaveStore(messageValidation);
            return false;
        }

        return  true;
    }

    private preparePermissionFormAfterSave = (userId:number) => {

        if(!userId) {
            userId = this.state.permission.user_id;
        }

        this.setState({
            permission: {
                profile_id: 0,
                publisher_id: 0,
                publisher_name: '',
                store_id: 0,
                store_name: '',
                user_id: userId,
                user_name: this.state.permission.user_name
            },
            publishers: [],
            stores: [],
            users: []
        });
    }

    /**
     * Métodos mensagem de alert
     */
    private alertStyle = () => {
        return styles[this.state.alertType];
    }

    private storeSuccessSaved() {
        this.openAlert(true, 'success', 'Cadastro realizado com sucesso.');
    }

    private errorSaveStore(msg: string) {
        this.openAlert(true, 'error', msg || 'Falha ao salvar registro.');
    }

    private openAlert(alertOpened: boolean, alertType: string, alertMessage: string) {
        this.setState({ alertType })
        this.setState({ alertMessage })
        this.setState({ alertOpened })
    }

    private closeAlert = (event: object, reason: string) => {
        if (reason === 'clickaway') {
            return;
        }
        this.setState({ alertOpened: false });
    }

    /**
     * Métodos select perfil
     */
    private handleChangeSelect = (event: any) => {
        const permission = Object.assign({}, this.state.permission);
        permission[event.target.name] = event.target.value;
        this.setState({ permission });
    };
    
    /**
     * Métodos select autocomplete usuário
     */
    private getSuggestionValueUser = (suggestion:any) => suggestion.fullname;

    private renderSuggestionUser = (suggestion:any) => {
        return (
            <Paper>
                <MenuItem className="suggestion">
                    <span>
                        {suggestion.fullname}
                    </span>
                </MenuItem>
            </Paper>
        );
    }

    private onChangeUser = (event:object, newValue:any) => {
        const permission = Object.assign({}, this.state.permission);
        permission.user_name = newValue.newValue;
        permission.user_id = 0;
        this.setState({ permission });
    };
    
    private onSuggestionsFetchRequestedUser = (value:any) => {
        this.setState({
            users: this.getSuggestionsUser(value)
        });
    };

    private getSuggestionsUser = (input:any) => {
        const inputValue = input.value.trim().toLowerCase();
        const inputLength = inputValue.length;

        return this.state.allUsers.filter(user => user.fullname.toLowerCase().slice(0, inputLength) === inputValue);
    };
    
    private onSuggestionSelectedUser = (event:object, selected: any ) => {
        const permission = Object.assign({}, this.state.permission);
        permission.user_id = selected.suggestion.id;
        permission.user_name = selected.suggestion.fullname;

        this.setState({ permission });
    };

    private onSuggestionsClearRequestedUser = () => {
        this.setState({
            users: []
        });
    };

    /**
     * Métodos select autocomplete livraria
     */
   private getSuggestionValueStore = (suggestion:any) => suggestion.tranding_name;

   private renderSuggestionStore = (suggestion:any) => {
       return (
            <Paper>
                <MenuItem className="suggestion">
                    <span>
                        {suggestion.tranding_name}
                    </span>
                </MenuItem>
            </Paper>
       );
   }

   private onChangeStore = (event:object, newValue:any) => {
       const permission = Object.assign({}, this.state.permission);
       permission.store_name = newValue.newValue;
       permission.store_id = 0;
       this.setState({ permission });
   };
   
   private onSuggestionsFetchRequestedStore = (value:any) => {
       this.setState({
           stores: this.getSuggestionsStore(value)
       });
   };

   private getSuggestionsStore = (input:any) => {
       const inputValue = input.value.trim().toLowerCase();
       const inputLength = inputValue.length;

       return this.state.allStores.filter(store => store.tranding_name.toLowerCase().slice(0, inputLength) === inputValue);
   };
   
   private onSuggestionSelectedStore = (event:object, selected: any ) => {
       const permission = Object.assign({}, this.state.permission);
       permission.store_id = selected.suggestion.id;
       permission.store_name = selected.suggestion.tranding_name;

       this.setState({ permission });
   };

   private onSuggestionsClearRequestedStore = () => {
       this.setState({
           stores: []
       });
   };

    /**
     * Métodos select autocomplete editora
     */
    private getSuggestionValuePublisher = (suggestion:any) => suggestion.provider;

    private renderSuggestionPublisher = (suggestion:any) => {
        return (
            <Paper>
                <MenuItem className="suggestion">
                    <span>
                        {suggestion.provider}
                    </span>
                </MenuItem>
            </Paper>
        );
    }
 
    private onChangePublisher = (event:object, newValue:any) => {
        const permission = Object.assign({}, this.state.permission);
        permission.publisher_name = newValue.newValue;
        permission.publisher_id = 0;
        this.setState({ permission });
    };
    
    private onSuggestionsFetchRequestedPublisher = (value:any) => {
        this.setState({
            publishers: this.getSuggestionsPublisher(value)
        });
    };
 
    private getSuggestionsPublisher = (input:any) => {
        const inputValue = input.value.trim().toLowerCase();
        const inputLength = inputValue.length;
 
        return this.state.allPublishers.filter(publisher => publisher.provider.toLowerCase().slice(0, inputLength) === inputValue);
    };
    
    private onSuggestionSelectedPublisher = (event:object, selected: any ) => {
        const permission = Object.assign({}, this.state.permission);
        permission.publisher_id = selected.suggestion.id;
        permission.publisher_name = selected.suggestion.provider;
 
        this.setState({ permission });
    };
 
    private onSuggestionsClearRequestedPublisher = () => {
        this.setState({
            publishers: []
        });
    };

    /**
     * Métodos que buscam dados a serem apresentados nos selects
     */
    private getUsers () {
        const body = {
            "operationName":"",
            "query":QUERY_GET_USERS
        };

        Rest.GraphqlPOST(body)
            .then( result  => {
                this.setState({ allUsers: result.data.data.allActiveUsers});
            });
    };

    private getBookstores () {
        const body = {
            "operationName":"",
            "query":QUERY_GET_BOOKSTORES
        };

        Rest.GraphqlPOST(body)
            .then( result  => {
                this.setState({ allStores: result.data.data.allActiveBookstores});
            });
    };

    private getPublishers () {
        const body = {
            "operationName":"",
            "query":QUERY_GET_PUBLISHERS
        };

        Rest.GraphqlPOST(body)
            .then( result  => {
                this.setState({ allPublishers: result.data.data.allActivePublishers});
            });
    };

    private getProfiles () {
        const body = {
            "operationName":"",
            "query":QUERY_GET_PROFILES
        };

        Rest.GraphqlPOST(body)
            .then( result  => {
                this.setState({ allProfiles: result.data.data.allActiveProfiles});
            });
    }
}



// WEBPACK FOOTER //
// ./src/component/administration/permissions/Permission.tsx